import React, { useState, useEffect, useCallback } from 'react';

/**
 * Bottom info overlay for Lecture Clips viewer.
 * Enhanced version of ShortsInfo with:
 * - Language badge (small pill)
 * - Auto-hide after 4 seconds (re-show on clip change)
 *
 * Matches production .shorts-info CSS classes.
 */
const ClipsInfo = ({ speakerName, title, publishedAt, language }) => {
  const [hidden, setHidden] = useState(false);

  // Generate @handle from speaker name (matches production ShortsInfo.js)
  const getSpeakerHandle = (name) => {
    if (!name) return '@Speaker';
    return '@' + name.replace(/\s+/g, '');
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return '';
    try {
      const date = new Date(dateStr);
      return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
    } catch (_) {
      return '';
    }
  };

  // Auto-hide after 4 seconds
  useEffect(() => {
    setHidden(false);
    const timer = setTimeout(() => setHidden(true), 4000);
    return () => clearTimeout(timer);
  }, [speakerName, title]); // Reset on clip change

  // Allow toggling via window function (called by Info action button)
  const toggle = useCallback(() => {
    setHidden(prev => !prev);
  }, []);

  // Expose toggle globally for the Info action button
  useEffect(() => {
    window.toggleClipsInfo = toggle;
    return () => { window.toggleClipsInfo = null; };
  }, [toggle]);

  return (
    <div className={`shorts-info ${hidden ? 'auto-hidden' : ''}`}>
      <div className="info-content">
        <div className="speaker-handle">
          {getSpeakerHandle(speakerName)}
          {language && (
            <span className="language-badge" style={{
              display: 'inline-block',
              padding: '1px 6px',
              borderRadius: '4px',
              fontSize: '10px',
              fontWeight: 600,
              background: 'rgba(255,255,255,0.2)',
              color: 'rgba(255,255,255,0.8)',
              textShadow: 'none',
              marginLeft: '4px',
            }}>
              {language}
            </span>
          )}
          {publishedAt && (
            <span className="speaker-date"> - {formatDate(publishedAt)}</span>
          )}
        </div>
        <div className="video-title">
          {title || 'Untitled'}
        </div>
      </div>
    </div>
  );
};

export default ClipsInfo;
